<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Mượn - Trả trực tuyến', href: '/facility/borrows' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
          <v-icon left>mdi-plus</v-icon> Đăng ký mượn thiết bị
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BorrowFilter @onFilterChanged="onFilterChange" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <BorrowDataTable ref="borrowDataTable" />
    </v-card>

    <BorrowNewDialog :state="newDialog" @updated="onFilterChange()" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import BorrowDataTable from '@/modules/facility/borrow/BorrowDataTable.vue'
import BorrowFilter from '@/modules/facility/borrow/BorrowFilter.vue'

export default {
  name: 'FacilityBorrows',
  components: {
    Breadcrumbs,
    BorrowDataTable,
    BorrowFilter,
    BorrowNewDialog: () => import('@/modules/facility/borrow/BorrowNewDialog.vue')
  },
  data() {
    return {
      newDialog: false
    }
  },
  methods: {
    async refresh(query) {
      this.$refs.borrowDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    }
  }
}
</script>
